import blickComp from '../components/blick-comp.vue'
import CoolFeaturesSlider from '../includes/CoolFeaturesSlider.js'
export default {
  name: 'project-browser',
  components: {
    blickComp,
    CoolFeaturesSlider
  },
  data(){
    return {
    }
  },
  mounted(){
    this.$root.$data.showBlick$
      .filter(data=> data.to == 'browser-window')
      .throttleTime(5000)
      .subscribe(data=>{
        this.$refs.blick.animate();
      })
  }
}



// WEBPACK FOOTER //
// ./src/includes/ProjectBrowser.js